<div class="header">
  <div>
    <h2>Leaves System</h2>
    <p>
      Track, manage, and monitor employee leaves efficiently to ensure smooth
      workflow and attendance compliance.
    </p>
  </div>
  <button class="add-btn" (click)="openAddModal()">
    <img src="assets/images/PlusIcon.svg" alt="" />Add New Leaves
  </button>
</div>
<div class="leaves-stat">
  <!-- SKELETON -->
  <ng-container *ngIf="showSkeleton">
    <div class="statCard">
      <div
        class="skeleton-row"
        style="height: 50px; width: 100%; margin: 0"
      ></div>
    </div>
    <div class="statCard">
      <div
        class="skeleton-row"
        style="height: 50px; width: 100%; margin: 0"
      ></div>
    </div>
    <div class="statCard">
      <div
        class="skeleton-row"
        style="height: 50px; width: 100%; margin: 0"
      ></div>
    </div>
  </ng-container>

  <!-- REAL DATA -->
  <ng-container *ngIf="!showSkeleton">
    <div class="statCard">
      <div class="stat-data">
        <div class="stat-icon">
          <img src="assets/images/leaveStat1.png" alt="" srcset="" />
        </div>
        <div class="stat-heading">
          <p>Total</p>
          <h2>Leaves</h2>
        </div>
      </div>
      <div class="stat-text">{{ getTotalLeavesCount() }}</div>
    </div>
    <div class="statCard">
      <div class="stat-data">
        <div class="stat-icon">
          <img src="assets/images/leaveStat2.png" alt="" srcset="" />
        </div>
        <div class="stat-heading">
          <p>Total</p>
          <h2>Paid Leaves</h2>
        </div>
      </div>
      <div class="stat-text">{{ getTotalPaidCount() }}</div>
    </div>
    <div class="statCard">
      <div class="stat-data">
        <div class="stat-icon">
          <img src="assets/images/leaveStat3.png" alt="" srcset="" />
        </div>
        <div class="stat-heading">
          <p>Total</p>
          <h2>Unpaid Leaves</h2>
        </div>
      </div>
      <div class="stat-text">{{ getTotalUnpaidCount() }}</div>
    </div>
  </ng-container>
</div>
<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Leave Type</th>
          <th>Leave Count</th>
          <th>Team Lead Action</th>
          <th>Gender Applicability</th>
          <th class="text-right pr-5">Action</th>
        </tr>
      </thead>

      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of leaves; track item.id) {
          <tr>
            <td>
              {{ item.leave_name | titlecase }} 
              @if (item.compulsary_leave == 1) {
                <span class="essential-leave">(Essential)</span>
              }
            </td>
            <td>
              <span
                class="badge"
                [ngClass]="'badge-' + (item.leave_type?.toLowerCase() || '')"
                >{{ item.leave_type }}</span
              >
            </td>
            <td>{{ item.leave_count }}</td>
            <td>
              @if (item.team_lead_action_type == 0) {
                Recommendation
              } @else if (item.team_lead_action_type == 1) {
                Approval
              }
            </td>
            <td>
              @if (item.gender_applicability == 1) {
                Male only
              } @else if (item.gender_applicability == 0) {
                Female only
              } @else if (item.gender_applicability == 2) {
                Both
              }
            </td>
            <td class="text-right icon-btns">
              <button class="btn-icon">
                <img src="assets/images/hierarcyIcon.svg" alt="Edit" />
              </button>
              <button class="btn-icon" (click)="openEditModal(item)">
                <img src="assets/images/editIcon.svg" alt="Edit" />
              </button>
              <button class="btn-icon" (click)="openDeleteModal(item.id)">
                <img src="assets/images/trashIcon.svg" alt="Delete" />
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<app-add-popup
  *ngIf="showModal"
  [title]="isEditMode ? 'Edit Leaves' : 'Add New Leaves'"
  [subtitle]="
    isEditMode
      ? 'Edit leaves entry to keep attendance records up to date.'
      : 'Create a new expense category to manage your expenses effectively.'
  "
  [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  "
  (close)="toggleModal()"
>
  <form [formGroup]="leaveForm" (ngSubmit)="onSave()">
    <div class="grid-row">
      <div class="input-group">
        <label>Leaves Title*</label>
        <input
          type="text"
          formControlName="leave_name"
          placeholder="Write here"
          class="pill-input"
        />
      </div>
      <div class="input-group">
        <label>Leaves Number*</label>
        <input
          type="text"
          formControlName="leave_count"
          placeholder="Write here"
          class="pill-input"
        />
      </div>
    </div>

    <div class="grid-row">
      <div class="input-group">
        <label>Leaves Type*</label>
        <div class="select-wrapper">
          <select formControlName="leave_type" class="pill-input">
            <option [ngValue]="null" disabled>Choose from here</option>
            <option value="paid">Paid Leaves</option>
            <option value="unpaid">Unpaid Leaves</option>
          </select>
        </div>
      </div>

      <div class="input-group">
        <label>Gander Applicability*</label>
        <div class="select-wrapper">
          <select formControlName="gender_applicability" class="pill-input">
            <option [ngValue]="null" disabled>Choose from here</option>
            <option [ngValue]="2">Both</option>
            <option [ngValue]="1">Male</option>
            <option [ngValue]="0">Female</option>
          </select>
        </div>
      </div>
    </div>

    <div class="checkbox-group">
      <input
        type="checkbox"
        id="essential"
        [checked]="compulsoryLeave"
        (change)="toggleCompulsoryLeave($event)"
      />
      <label for="essential">Are these leaves essential?</label>
    </div>

    <div class="checkbox-group">
      <label>Team Lead Action</label>
      <div class="radio-group">
        <label>
          <input
            class="mr-1"
            type="radio"
            name="teamLeadAction"
            [value]="0"
            [checked]="teamLeadActionType === 0"
            (change)="changeTeamLeadAction(0)"
          />
          Recommendation
        </label>
        <label>
          <input
            class="mr-1"
            type="radio"
            name="teamLeadAction"
            [value]="1"
            [checked]="teamLeadActionType === 1"
            (change)="changeTeamLeadAction(1)"
          />
          Approval
        </label>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal()">
        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="leaveForm.invalid">
        <img src="assets/images/savePopup.svg" alt="" /> Save
      </button>
    </div>
  </form>
</app-add-popup>
<!-- Delete Confirmation Modal -->
<app-add-popup
  *ngIf="showDeleteModal"
  title="Delete Leave"
  subtitle="Are you sure you want to delete this leave? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg"
  (close)="closeDeleteModal()"
>
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="closeDeleteModal()">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span>Delete
    </button>
  </div>
</app-add-popup>
